const t = async () => new Promise((e) => {
  setTimeout(() => {
    requestAnimationFrame(e);
  });
}), n = async (e) => {
  for (; !document.body.contains(e); )
    await t();
};
export {
  n as waitForElementInDOM,
  t as waitForNextRender
};
